import React, { Component } from 'react'

import numeral from 'numeral'

import { CheckIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/CheckIcon'
import { CopyIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/CopyIcon'
import { ExclamationIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/ExclamationIcon'
import { MinusIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/MinusIcon'
import { Tooltip } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/tooltip/Tooltip'
import { colors } from '@lyrahealth-inc/ui-core-crossplatform/src/styles/colors'

import styles from './paymentHistoryCard.module.scss'

type Props = {
  data?: any // TODO: PropTypes.instanceOf(Map)
  copyClick: (...args: any[]) => any
  viewClick: (...args: any[]) => any
  isPracticeAdmin?: boolean
}

const PaymentCardTooltip: React.FC<React.PropsWithChildren<any>> = ({ children, appointment_id }) => {
  const isEngageCharge = !!appointment_id
  const toolTipMessage = isEngageCharge
    ? "Invoices submitted via your Lyra Calendar cannot be copied to the Legacy Payment Form. To bill for this client's next session, please invoice and submit note from the Lyra Calendar appointment."
    : 'If you are submitting an invoice for an existing client, you have the option of duplicating a previously approved invoice by clicking the icon to the left of that invoice. This will copy over the patient’s information (including Name, Date of Birth, and Diagnosis) to the Request Payment Page.'
  return (
    <Tooltip content={toolTipMessage} hoverEnabled={true} wrapperStyle={{ flexGrow: 0 }}>
      {children}
    </Tooltip>
  )
}

class PaymentHistoryCard extends Component<Props> {
  _onViewClick = () => {
    const { viewClick, data } = this.props
    viewClick(data)
  }

  _configureStatus = (data: any) => {
    const status = data.status.toLowerCase()
    if (status === 'approved') {
      return (
        <p>
          <b>Status: </b>
          <span className={styles['icon-container']}>
            <CheckIcon fillColor={styles.x_success} isFilled size={15} withCircle />
          </span>
          <span className={styles.approved}>{status}</span>
        </p>
      )
    } else if (status === 'rejected') {
      return (
        <p>
          <b>Status: </b>
          <span className={styles['icon-container']}>
            <ExclamationIcon isFilled size={15} fillColor={styles.x_alert} />
          </span>
          <span className={styles.rejected}>{status}</span>
        </p>
      )
    } else if (status === 'reversed') {
      return (
        <p>
          <b>Status: </b>
          <span className={styles['icon-container']}>
            <MinusIcon isFilled width={15} fillColor={styles.x_highlight} />
          </span>
          <span className={styles.reversed}>{status}</span>
        </p>
      )
    } else {
      return (
        <p>
          <b>Status: </b>
          {['pending', 'pending_note'].includes(status) ? 'submitted' : status}
        </p>
      )
    }
  }

  render() {
    const { data, isPracticeAdmin } = this.props
    const referenceNumber = data.reference_number ? `#${data.reference_number}` : null
    const appointment_id = data.appointment_id
    return (
      <div className={styles['history-list-row']}>
        <PaymentCardTooltip appointment_id={appointment_id}>
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
          <div
            data-test-id='PaymentHistoryCard-copy'
            className={styles.copy}
            onClick={() => {
              // If the charge has an appointment ID, this is an Engage charge
              // Provider should not be copying/submitting payment for this patient using the Request Payment Form since sessions should be booked/closed using In-Product Calendar
              if (appointment_id) return
              this.props.copyClick(data.id)
            }}
          >
            <div className={styles['icon-only']}>
              <CopyIcon size={15} fillColor={appointment_id ? colors.ui_oatmeal5 : styles.x_primary_action} />
            </div>
          </div>
        </PaymentCardTooltip>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
        <div
          className={styles.card}
          onClick={() => {
            this._onViewClick()
          }}
        >
          <div className={styles.content} data-test-id='PaymentHistoryCard'>
            {isPracticeAdmin ? (
              <div className={styles.left}>
                <div className={styles.details}>
                  <h4>
                    {data.first_name} {data.last_name}
                  </h4>
                  <p>
                    {data.visit_date}
                    <span className={styles.reference}>{referenceNumber}</span>
                  </p>
                </div>
                <div className={styles.details}>
                  <h4>Provider Name</h4>
                  <p>
                    {data.provider_first_name} {data.provider_last_name}
                  </p>
                </div>
              </div>
            ) : (
              <div className={styles.left}>
                <h4>
                  <span>
                    {data.first_name} {data.last_name}
                  </span>
                </h4>
                <div className={styles.date}>{data.visit_date}</div>
                <div className={styles.reference}>{referenceNumber}</div>
              </div>
            )}
            <div className={styles.right}>
              {this._configureStatus(data)}
              <div className={styles.amount}>
                <h3>{numeral(data.session_rate / 100).format('$0,0[.]00')}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PaymentHistoryCard
